/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useState } from "react";
import { Card, CardBody, Col, ButtonToolbar, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { MdModeEdit, MdInsertDriveFile, MdError } from "react-icons/md";
import DataTable from "../../../../shared/components/DataTable";
import { withRouter } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import AccessControl from "../../../../shared/components/AccessControl";
import SCPIssuersDropDown from "../../../Issuers/SCPIssuersDropDown";
import CustomSearch from "./CustomSearch";

const IssuerConfigTable = memo(({ dataState, fetchData, permissions, issuerConfigs, history, location, getIssuersConfigALL }) => {
    const [searchKey, setSearchKey] = useState("");
    const count = dataState && dataState.response ? dataState.response.count : 0;

    const columns = [
        {
            accessor: "name",
            name: "Configuration Name",
            sortable: true,
            sortKey: "name",
        },

        {
            accessor: "cardProgram",
            name: "Card Program",
            sortable: true,
            sortKey: "card_program",
        },
        {
            accessor: "emvProfileCode",
            name: "EMV Profile",
            sortable: true,
            sortKey: "emv_profile_code",
        },
        {
            accessor: "cardScheme",
            name: "Card Scheme",
            sortable: true,
            sortKey: "card_scheme",
        },
    ];

    const handleAction = (row, action) => {
       
        if (action.name === "view_configurations") {
            history.push(`${location.pathname}/view/${row.issuerCode}/${row.name}`);
        } else if (action.name === "edit_configurations") {
            history.push(`${location.pathname}/edit/${row.issuerCode}/${row.name}`);
        }
    };

    const sortFn = (page, pageSize, column) => {
        let sortOrder = "ASC";
        if (!issuerConfigs.loading) {
            if (issuerConfigs.request && issuerConfigs.request.sortOrder) {
                sortOrder = issuerConfigs.request.sortOrder === "ASC" ? "DESC" : "ASC";
            }
            fetchData({
                ...issuerConfigs.request,
                page,
                pageSize,
                sortKey: column.sortKey,
                sortOrder,
            });
        }
    };

    const actions = [
        {
            name: "view_configurations",
            btnText: "View Configuration",
            btnAction: handleAction,
            btnClass: "success",
            btnIcon: MdInsertDriveFile,
            permissions: [permissionsConstants.VIEW_ISSUER_CONFIGURATION],
        },
        {
            name: "edit_configurations",
            btnText: "Edit Configuration",
            btnAction: handleAction,
            btnClass: "default",
            btnIcon: MdModeEdit,
            permissions: [permissionsConstants.UPDATE_ISSUER_CONFIGURATION],
        },
    ];

    const handleSubmit = (values) => {
        setSearchKey(values.searchWord);
        fetchData({
            ...issuerConfigs.request,
            page: 1,
            searchWord: values.searchWord || "",
        });
    };
    const onSearchBarChange = () => {
        getIssuersConfigALL();
    };
    const loadData = (page, pageSize) => {
       
        try {
            if (issuerConfigs && issuerConfigs.request && issuerConfigs.request.issuerCode) {
                fetchData({
                    ...issuerConfigs.request,
                    page,
                    pageSize,
                });
            } else {
                fetchData({
                    ...issuerConfigs.request,
                    page,
                    pageSize,
                    searchWord: searchKey,
                });
            }
        } catch (err) {
            console.error(MdError);
        }
        // fetchData({
        //   ...issuerConfigs.request,
        //   page,
        //   pageSize,
        //   searchWord: searchKey
        // });
    };

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">Issuer Card Configurations</h5>
                        <AccessControl allowedPermissions={[permissionsConstants.CREATE_ISSUER_CONFIGURATION]} renderNoAccess={() => null}>
                            <ButtonToolbar className="products-list__btn-toolbar-top">
                                <Link className="btn btn-primary products-list__btn-add" to="/issuers/config/new" id="link-create-config">
                                    Create new configuration
                                </Link>
                            </ButtonToolbar>
                        </AccessControl>
                    </div>
                    <Row>
                        <Col lg="4">
                            <AccessControl allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]} renderNoAccess={() => null}>
                                <SCPIssuersDropDown required id="issuer" label="Select Issuer" />
                            </AccessControl>
                        </Col>
                    </Row>
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={dataState && dataState.response ? dataState.response.content : []}
                        count={count}
                        permissions={permissions}
                        countName="configurations"
                        defaultPageSize={10}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        bordered={true}
                        striped={true}
                        hover={true}
                        customSearch={
                            <CustomSearch
                                pageNumer={1}
                                initialValues={{
                                    pageNumber: 1,
                                    pageSize: 10,
                                    searchKey: "",
                                }}
                                pageSize={10}
                                onSubmit={handleSubmit}
                                onSearchBarChange={onSearchBarChange}
                            />
                        }
                        sortFn={sortFn}
                        actions={actions}
                        searchKey={searchKey}
                        responsive
                        serverside
                    />
                </CardBody>
            </Card>
        </Col>
    );
});

const selector = formValueSelector("fetchConfigs");

export default withRouter(
    reduxForm({
        form: "fetchConfigs",
        destroyOnUnmount: false,
    })(
        connect((state) => ({
            selectedIssuer: selector(state, "scpIssuers"),
            issuerConfigs: state.getAllIssuerConfig,
            permissions: state.permissions && state.permissions.response,
        }))(IssuerConfigTable)
    )
);
